export const menu = {
    namespaced: true,
    state: {
        headerStyle: "",
        prevHeaderStyle: [],
        menuOpen: false,
        totalProgressSteps: 0,
        currentProgressStep: 0,
        menuItems: [
            /*{
                title: 'Quiz',
                href: '/quiz',
                menuItemComponent: 'quizzes/quiz-button.vue'
            },*/
            {
                title: "My Outfits",
                href: "/saved-outfits",
                isMenuExpanded: false,
            },
            {
                title: "Favorite Items",
                href: "/saved-items",
                isMenuExpanded: false,
            },
            {
                title: "Style & Preferences",
                menuContent: "style-settings",
                component: "style-settings/style-settings.vue",
                isMenuExpanded: true,
            },
            {
                title: "Order History",
                menuContent: "my-orders",
                component: "my-orders/my-orders.vue",
                isMenuExpanded: true,
            },
            {
                title: "Personal Info",
                menuContent: "account-settings",
                component: "account-settings/account-settings.vue",
                isMenuExpanded: true,
            },
            {
                title: "Invite Friends",
                handler: "INVITE_FRIENDS",
                isMenuExpanded: false,
            },
        ],
        currentMenuContentPage: "main-menu",
        currentMenuComponent: "main-menu/main-menu.vue",
        currentMenuToken: "",
        isMenuExpanded: false,
        returnPage: {
            href: "",
            title: "",
        },
    },
    getters: {
        headerStyle(state) {
            return state.headerStyle.headerStyle;
        },
        menuItems(state) {
            return state.menuItems;
        },
        menuOpen(state) {
            return state.menuOpen;
        },
        returnPage(state) {
            return state.returnPage;
        },
        getCurrentProgressStep(state) {
            return state.currentProgressStep;
        },
        getTotalProgressSteps(state) {
            return state.totalProgressSteps;
        },
        currentMenuContentPage(state) {
            return state.currentMenuContentPage;
        },
        currentMenuComponent(state) {
            return state.currentMenuComponent;
        },
        currentMenuToken(state) {
            return state.currentMenuToken;
        },
        isMenuExpanded(state) {
            return state.isMenuExpanded;
        },
    },
    mutations: {
        headerStyle(state, value) {
            state.headerStyle = value;
        },
        hideHeader(state) {
            state.prevHeaderStyle.push(state.headerStyle);
            state.headerStyle = {
                headerStyle: "hidden",
            };
        },
        resetHeader(state) {
            state.headerStyle = state.prevHeaderStyle.pop() || "";
        },
        setMenuOpen(state, payload) {
            state.menuOpen = payload.open;
        },
        toggleMenu(state) {
            state.menuOpen = !state.menuOpen;
        },
        setReturnPage(state, payload) {
            state.returnPage.href = payload.href;
            state.returnPage.title = payload.title;
        },
        setCurrentProgressStep(state, stepNumber) {
            state.currentProgressStep = stepNumber;
        },
        setTotalProgressSteps(state, totalSteps) {
            state.totalProgressSteps = totalSteps;
        },
        setCurrentMenuItem(state, payload) {
            if (payload.item.menuContent && payload.item.component) {
                state.currentMenuContentPage = payload.item.menuContent;
                state.currentMenuComponent = payload.item.component;
            }
            if (payload.item.token) {
                state.currentMenuToken = payload.item.token;
            }
            if (typeof payload.item.isMenuExpanded !== "undefined") {
                state.isMenuExpanded = payload.item.isMenuExpanded;
            }
        },
    },
    actions: {},
};
